import { createDatadogError } from '../datadog/utils/createDatadogError';

export namespace ExperimentServiceDomain {
    export enum ActiveExperiment {
        PATHFINDERS_HUMAN_FRIENDLY_ERROR_CODES = 'PATHFINDERS_HUMAN_FRIENDLY_ERROR_CODES',
        HOME_LOANS_DASHBOARD_AUTH_MIGRATION = 'HOME_LOANS_DASHBOARD_AUTH_MIGRATION',
        ZHLPE_DASHBOARD_ACTIVATION_EMAIL_LOGIN_HINT = 'ZHLPE_DASHBOARD_ACTIVATION_EMAIL_LOGIN_HINT',
        PATHFINDERS_UNIVERSALFLOW_CALLSCHEDULER = 'PATHFINDERS_UNIVERSALFLOW_CALLSCHEDULER',
    }

    export enum FeatureFlagStatus {
        OFF = 'off',
        ON = 'on',
    }

    export const EXPERIMENTS_LOG_PREFIX = '[EXPERIMENTS]';
    export const UnknownExperimentError = createDatadogError('UnknownExperimentError', EXPERIMENTS_LOG_PREFIX);
}
